import React from "react";

import Header from "../components/header/header";
import Company from "../components/introduction_page/company/company";
import Footer from "../components/footer/footer";

const Companyontainer = () => {
    return (
        <>
            <Header linkFlag="company" />
            <Company />
            <Footer />
        </>
    )
}

export default Companyontainer;